// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3VsP7","list":"styles_list__2FCXx"};